import ControllerBase from 'global/js/ControllerBase';

export default class ControllerFhwProfileJumpToSection extends ControllerBase {
	private buttonAtomComponents: HTMLAnchorElement[];

	constructor(element: HTMLElement) {
		super(element);
		this.getButtonEvent = this.getButtonEvent.bind(this)
		this.observeClick = this.observeClick.bind(this)
		this.init();
	}

	private init() {
		this.buttonAtomComponents = Array.from(this.$element.querySelectorAll('.fhw-jump-to-item'));

		if (this.buttonAtomComponents) {
			[...this.buttonAtomComponents].forEach((button) => this.getButtonEvent(button));
		}
	}

	getButtonEvent(button: HTMLAnchorElement): void {
		button.addEventListener('click', (e: CustomEvent<Event | MouseEvent>) => this.observeClick(e, button));
	}

	private observeClick(e: CustomEvent<Event | MouseEvent>, button: HTMLAnchorElement) {
		e.preventDefault();

		const target = button.dataset.jumpto;

		if (e && e.detail && target) {
			const section = document.getElementById(target);
			section && section.scrollIntoView();
		}
	}
}
